<template>
  <div class="page">
    <PageHeader>
      Депозиты
    </PageHeader>
    <div class="content" v-if="loaded">
      <LedgerDepositesComponent />
    </div>
  </div>
</template>
<script>
import LedgerDepositesComponent from "../Ledger/components/Balances/deposites.vue";
import PageHeader from "../../ui/PageHeader.vue";

export default {
  name: "Deposits",
  components: { PageHeader, LedgerDepositesComponent },
  data: () => ({
    loaded: true
  }),
  computed: {},
  methods: {},
  async mounted() {}
};
</script>
<style></style>



// WEBPACK FOOTER //
// src/components/pages/Deposits/index.vue